var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 92,
    viewBox: "0 0 86 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_9467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 76,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7975 7.96686C35.7228 7.01694 32.3749 7.78095 30.0167 9.97068L7.99779 30.4168C5.64255 32.6038 4.63234 35.8809 5.34743 39.0144L12.0408 68.3447C12.7559 71.4782 15.0877 73.9925 18.1586 74.9413L46.8676 83.8109C49.9423 84.7609 53.2902 83.9969 55.6483 81.8071L77.6673 61.361C80.0225 59.174 81.0327 55.8969 80.3177 52.7634L73.6243 23.4331C72.9092 20.2996 70.5773 17.7853 67.5065 16.8365L38.7975 7.96686ZM46.4721 61.8522C55.1222 56.7218 57.8559 41.7043 56.939 34.4489C52.8382 29.8311 44.1405 28.7932 39.1858 29.9239C34.2311 31.0546 26.8447 35.763 25.1533 41.7026C27.4747 48.6375 36.4527 60.9823 46.4721 61.8522Z",
    fill: "url(#paint0_linear_1772_9467)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_9467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.20703,
    y: 16.4219,
    width: 76.9533,
    height: 78.1818,
    transform: "rotate(-12.8552 -6.20703 16.4219)",
    fill: "url(#paint1_linear_1772_9467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9812 33.1495C74.136 59.472 55.5596 63.3488 46.4191 61.8374L25.797 38.8661L16.0335 47.0582L22.2553 74.3219L44.0469 84.8799L98.2708 81.6823C92.3598 54.537 79.8264 6.82695 76.9812 33.1495Z",
    fill: "url(#paint2_linear_1772_9467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9398 34.4462C46.3211 11.9463 21.2468 17.1139 9.61445 22.4264C-2.03208 25.7139 -2.81155 44.1922 -1.74547 53.0204L11.0898 83.2852L33.9587 79.8627C19.282 65.5581 21.8911 48.1932 25.1638 41.6977L56.9398 34.4462Z",
    fill: "url(#paint3_linear_1772_9467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_9467",
    x1: 34.1384,
    y1: 7.7914,
    x2: 51.5267,
    y2: 83.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_9467",
    x1: 46.903,
    y1: 28.4661,
    x2: 35.8184,
    y2: 75.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054746,
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1772_9467",
    x1: 77.784,
    y1: 52.207,
    x2: 22.0391,
    y2: 60.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1772_9467",
    x1: 14.3443,
    y1: 52.0844,
    x2: 45.8758,
    y2: 26.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdIcon);
export default __webpack_public_path__ + "static/media/NfdIcon.d04abbd2993fbfd13b7a4c3cba31a9fb.svg";
export { ForwardRef as ReactComponent };